<template>
    <div class="h-100 w-100 align-items-center d-flex justify-content-center">
        <div class="container">
            <div class="row justify-content-center">
                <div class="col-12 empty-image-container">
                    <slot name="image" />
                </div>
            </div>
            <div class="row justify-content-center">
                <div class="col-12 empty-caption-container d-flex justify-content-center">
                    <slot>
                        <pc-button-icon
                            outline
                            class="btn-outline-primary mt-3"
                            icon="plus-square"
                            v-on:click="$emit('button-click')">
                            {{ buttonText }}
                        </pc-button-icon>
                    </slot>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            buttonText: { type: String, required: false, default: "Get Started" }
        },
        emits: ["button-click"]
    };
</script>

<style lang="scss" scoped>
    .empty-image-container {
        width: 15%;
    }

    .empty-caption-container {
        width: 60%;
        font-size: larger;
    }
</style>
